module.exports = __webpack_public_path__ + "img/IMG-20190905-WA0014.6d05f723.jpg";